import {
  format as _format,
  subMonths as _subMonths,
  addMonths as _addMonths,
  addDays as _addDays,
  parseISO as _parseISO,
  // @ts-ignore
} from 'date-fns-2';

export const format = _format;
export const subMonths = _subMonths;
export const addMonths = _addMonths;
export const addDays = _addDays;
export const parseISO = _parseISO;
